var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSuspension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2199 5.71442C16.2199 6.84463 15.8847 7.94945 15.2568 8.88918C14.6289 9.82892 13.7364 10.5613 12.6923 10.9939C11.6481 11.4264 10.4991 11.5395 9.39061 11.319C8.28212 11.0986 7.26391 10.5543 6.46473 9.75513C5.66556 8.95595 5.12131 7.93774 4.90082 6.82925C4.68033 5.72076 4.79349 4.57178 5.226 3.52761C5.65851 2.48343 6.39095 1.59096 7.33068 0.963054C8.27041 0.335145 9.37523 0 10.5054 0C11.2559 0 11.9989 0.147808 12.6923 0.434984C13.3856 0.722161 14.0155 1.14308 14.5461 1.67372C15.0768 2.20435 15.4977 2.8343 15.7849 3.52761C16.0721 4.22091 16.2199 4.96399 16.2199 5.71442Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.885 13.134C17.9609 12.2009 16.8583 11.4636 15.6431 10.9658C14.4279 10.468 13.1248 10.2201 11.8117 10.2368H9.19222C7.84981 10.2183 6.51804 10.4772 5.28028 10.9971C4.04252 11.5171 2.92542 12.287 1.9989 13.2585C0.743159 14.5588 0.0286053 16.2878 0 18.0952L0 23.9959H21.0039V18.0952C20.9732 16.2271 20.2127 14.4451 18.885 13.1305",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47217 21.0781L14.1455 13.7842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16113 14.2974L14.455 20.9707",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSuspension);
export default __webpack_public_path__ + "static/media/headerSuspension.245a59f30874a14d6597bc05e39bb0f3.svg";
export { ForwardRef as ReactComponent };